import * as React from "react"
import { cn } from "../../utils"

type AvatarTone = "blue" | "emerald" | "amber" | "violet" | "slate" | "rose";

const TONE_CLASS: Record<AvatarTone, string> = {
  blue:    "from-[#2563eb] to-[#1e40af]",
  emerald: "from-emerald-500 to-emerald-700",
  amber:   "from-amber-500 to-amber-700",
  violet:  "from-violet-500 to-violet-700",
  slate:   "from-slate-500 to-slate-700",
  rose:    "from-rose-500 to-rose-700",
};

export interface AvatarProps extends React.HTMLAttributes<HTMLDivElement> {
  name: string;
  tone?: AvatarTone;
  size?: number;
}

const Avatar = React.forwardRef<HTMLDivElement, AvatarProps>(
  ({ name, tone = "blue", size = 32, className, style, ...props }, ref) => {
    const initials = name
      .split(" ")
      .map((x) => x[0])
      .slice(0, 2)
      .join("")
      .toUpperCase();

    return (
      <div
        ref={ref}
        className={cn(
          "rounded-full bg-gradient-to-br grid place-items-center text-white font-bold shrink-0",
          TONE_CLASS[tone],
          className
        )}
        style={{ width: size, height: size, fontSize: Math.round(size * 0.38), ...style }}
        {...props}
      >
        {initials}
      </div>
    );
  }
);
Avatar.displayName = "Avatar";

export { Avatar };
